const SearchIcon = () => {
  return (
    <svg
      width="28"
      height="31"
      viewBox="0 0 28 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 20C23.5228 20 28 15.5229 28 10C28 4.47705 23.5228 0 18 0C12.4772 0 8 4.47705 8 10C8 15.5229 12.4772 20 18 20ZM18 17C21.866 17 25 13.8662 25 10C25 6.13379 21.866 3 18 3C14.134 3 11 6.13379 11 10C11 13.8662 14.134 17 18 17Z"
        fill="#FFB800"
      />
      <line
        x1="9.21108"
        y1="20.1108"
        x2="2.11079"
        y2="28.7889"
        stroke="#FFB800"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};
export default SearchIcon;
